define('shared/util/promise/enclose',[
    './Result', 
    './break',
    'Promise'
], function (
    Result, 
    breakFunc,
    Promise
) {
    return function(chain) {
        return Promise.resolve(
            chain({
                break: breakFunc
            })
        )
            .then(function(){
                return null;
            }, function(err){
                if (err instanceof Result) {
                    return err.result;
                }
                return Promise.reject(err);
            });
    };
});
